import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import MUIIconButton from "../UI/MUIIconButton/MUIIconButton";
import { RING_ALIGN, barTrackStart } from "../../utils/indexScoreRingAlign";
import { INDEX_ACCENT, INDEX_TRACK, INDEX_TEXT, INDEX_TEXT_MUTED, INDEX_DIVIDER } from "../../utils/indexScoreTheme";

const SIZES = {

  large: {
    captionFont: 17.6, scoreFont: 20, subFont: 12,
    factorLabelFont: 13, barHeight: 14, gap: 24, axisFont: 11,
  },
  small: {
    captionFont: 12.5, scoreFont: 14, subFont: 9,
    factorLabelFont: 10.5, barHeight: 10, gap: 12, axisFont: 9.5,
  },
};

const AXIS_TICKS = [0, 20, 40, 60, 80, 100];

export default function DirectIndexScoreCard({ directScore, onInfoClick, size = "large" }) {
  if (!directScore) return null;
  const s = SIZES[size] ?? SIZES.large;

  const align = RING_ALIGN[size] ?? RING_ALIGN.large;
  const leftColWidth = barTrackStart(size) - s.gap;

  const pct = Math.min(100, Math.max(0, directScore.total)) / 100;

  return (
    <div style={{ width: "100%" }}>
      <div style={{ display: "flex", alignItems: "center", gap: s.gap, paddingLeft: align.inset, boxSizing: "border-box" }}>
        <div style={{ flexShrink: 0, width: leftColWidth }}>
 
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, marginBottom: 2 }}>
            <span style={{ display: "flex", alignItems: "center", gap: 4, minWidth: 0 }}>
              <span style={{ fontWeight: 700, fontSize: s.captionFont, color: INDEX_TEXT, whiteSpace: "nowrap" }}>Direct Index Score</span>
              <MUIIconButton data-html2canvas-ignore size="small" onClick={onInfoClick} style={{ padding: 2 }}>
                <InfoOutlinedIcon fontSize="small" />
              </MUIIconButton>
            </span>
            <span style={{ display: "flex", alignItems: "baseline", gap: 2, flexShrink: 0, lineHeight: 1 }}>
              <span style={{ fontWeight: 700, fontSize: s.scoreFont, color: INDEX_TEXT }}>{directScore.total}</span>
              <span style={{ fontSize: s.subFont, color: INDEX_TEXT_MUTED }}>/100</span>
            </span>
          </div>
          <div
            title={directScore.factorLabel}
            style={{ fontSize: s.factorLabelFont, color: INDEX_TEXT_MUTED, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
          >
            {directScore.factorLabel}
          </div>
        </div>

        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ position: "relative", height: s.barHeight, background: INDEX_TRACK, borderRadius: 999 }}>
            <div
              style={{
                position: "absolute",
                top: 0, left: 0, bottom: 0,
                width: `${pct * 100}%`,
                background: INDEX_ACCENT,
                borderRadius: 999,
              }}
            />
          </div>
          {/* 0-100 scale for this single bar, mirroring Composite's own 0-10 axis. */}
          <div style={{ display: "flex", marginTop: 4 }}>
            {AXIS_TICKS.map((tick, i) => (
              <span
                key={tick}
                style={{
                  flex: i === 0 || i === AXIS_TICKS.length - 1 ? "0 0 auto" : 1,
                  textAlign: i === 0 ? "left" : i === AXIS_TICKS.length - 1 ? "right" : "center",
                  fontSize: s.axisFont,
                  color: INDEX_TEXT_MUTED,
                }}
              >
                {tick}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div style={{ margin: size === "large" ? "16px 0" : "8px 0" }}>
        <span style={{ display: "block", height: 1, background: INDEX_DIVIDER }} />
      </div>
    </div>
  );
}
